import { render, staticRenderFns } from "./FileStep.vue?vue&type=template&id=6c24694a"
import script from "./FileStep.vue?vue&type=script&lang=js"
export * from "./FileStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports